export default "__VITE_ASSET__CnQ0vkJR__"